export default __webpack_public_path__ + "static/media/abbeville9.8a5ff9a2.jpg";